import React from "react";
import ReactDOM from "react-dom/client";
import { RootTemplate } from "templates/RootTemplate";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <RootTemplate />
  </React.StrictMode>
);
